export const authGroups = [
  'admin',
  'lbcoach',
];
